/**
 * Cắm cụm ví thanh toán vào DOM khi ngăn giỏ mở lần đầu.
 *
 * Vì sao cần: xem khối comment trong snippets/cart-summary.liquid. Tóm tắt —
 * Shopify nạp 3,8 MB / 136 request ngay khi thấy <shopify-accelerated-checkout-cart>
 * trong body, kể cả lúc ngăn giỏ đóng. Ta gói nó vào <template> ở Liquid; file này
 * lấy ra và cắm vào đúng lúc.
 *
 * KHÔNG cần tự gọi Shopify.PaymentButton.init(): bootstrap của Shopify trong
 * content_for_header đang giữ sẵn một MutationObserver trên document.body và
 * chỉ disconnect SAU KHI tìm thấy phần tử. Ta cắm vào là nó tự bắn.
 *
 * Vì sao phải theo dõi lâu dài chứ không chạy một lượt:
 * ngăn giỏ dựng lại toàn bộ phần tóm tắt qua Section Rendering API mỗi lần đổi
 * số lượng hoặc thêm món. Mỗi lần dựng lại là <template> quay về. Nếu chỉ cắm
 * một lần thì lần thứ hai khách mở ngăn giỏ sẽ không còn nút ví.
 */
(() => {
  const SU_KIEN_MO = 'theme-drawer:open';
  let daMo = false;
  let theoDoi = null;

  /** Thay <template> bằng nội dung thật. Trả về true nếu có cắm gì đó. */
  const cam = (root = document) => {
    const cacTemplate = root.querySelectorAll('template[data-wallets-payload]');
    if (!cacTemplate.length) return false;

    for (const tpl of cacTemplate) {
      const cha = tpl.parentElement;
      if (!cha) continue;
      cha.replaceChild(tpl.content.cloneNode(true), tpl);
    }
    return true;
  };

  /**
   * Sau lần mở đầu tiên, ngăn giỏ có thể dựng lại bất cứ lúc nào. Theo dõi phần
   * thân ngăn giỏ để cắm lại ngay khi <template> mới xuất hiện.
   */
  const batDauTheoDoi = () => {
    if (theoDoi) return;
    const goc = document.querySelector('cart-drawer-component') || document.body;
    theoDoi = new MutationObserver((dsThayDoi) => {
      for (const td of dsThayDoi) {
        for (const node of td.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('template[data-wallets-payload]') || node.querySelector?.('template[data-wallets-payload]')) {
            cam(goc);
            return;
          }
        }
      }
    });
    theoDoi.observe(goc, { childList: true, subtree: true });
  };

  document.addEventListener(SU_KIEN_MO, (e) => {
    /* Chỉ quan tâm ngăn giỏ, không phải mọi drawer của theme (menu, bộ lọc...). */
    if (!e.target?.closest?.('cart-drawer-component')) return;

    cam();
    if (!daMo) {
      daMo = true;
      batDauTheoDoi();
    }
  });

  /*
    Trường hợp ngăn giỏ đã mở sẵn lúc script này chạy — ví dụ khách bấm thêm vào
    giỏ rồi ngăn tự bật, hoặc trang khôi phục trạng thái mở từ history. Sự kiện
    open đã bắn xong trước khi ta kịp nghe.
  */
  if (document.querySelector('cart-drawer-component theme-drawer[open], theme-drawer[open] cart-drawer-component')) {
    cam();
    daMo = true;
    batDauTheoDoi();
  }
})();
